import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ImageType } from '@rma/dashboard/generic/orc/image-upload';
import { RMA_DEFAULT_HTTP_OPTIONS } from '@rma/dashboard/generic/util/environment';
import { ProfileType } from '@rma/generic/domain/types';
import { appendToRmaApiUrl } from '@rma/generic/ng/util';
import { Observable } from 'rxjs';
import { ProfileBranding } from '../models/branding.models';

@Injectable({
  providedIn: 'root',
})
export class ProfileThemeApiService {
  private readonly httpClient: HttpClient = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);

  public getBranding(profileType: ProfileType, profileCode: string): Observable<ProfileBranding> {
    return this.httpClient.get<ProfileBranding>(this.rmaApiUrl(`${profileType}/${profileCode}/Branding`), RMA_DEFAULT_HTTP_OPTIONS);
  }

  public uploadImage(
    profileType: ProfileType,
    profileCode: string,
    type: ImageType,
    fileName: string,
    isOriginal: boolean,
  ): Observable<Record<string, unknown>> {
    const baseUri = this.getBaseUri(profileType, profileCode);
    return this.httpClient.put<Record<string, unknown>>(
      this.rmaApiUrl(`${baseUri}${type}`),
      { fileName, isOriginal },
      RMA_DEFAULT_HTTP_OPTIONS,
    );
  }

  public deleteImage(profileType: ProfileType, profileCode: string, type: ImageType): Observable<Record<string, unknown>> {
    const baseUri = this.getBaseUri(profileType, profileCode);
    return this.httpClient.delete<Record<string, unknown>>(this.rmaApiUrl(`${baseUri}${type}`), RMA_DEFAULT_HTTP_OPTIONS);
  }

  public updateBrandKit(profileType: ProfileType, profileCode: string, brandKitId: number): Observable<void> {
    return this.httpClient.put<void>(
      this.rmaApiUrl(`${profileType}/${profileCode}/ProfileTheme/BrandKit`),
      { brandKitId },
      RMA_DEFAULT_HTTP_OPTIONS,
    );
  }

  private getBaseUri(profileType: ProfileType, profileCode: string): string {
    const path = `${profileType}/${profileCode}/ProfileTheme/`;
    return this.rmaApiUrl(path);
  }
}
